import { ICustomerType } from "@/core/model/sys/ICustomer";
import IParamServices from "../IParamServices";
import BaseService from "./BaseService";
import { IServiceResponse } from "@/core/model/rest/IServiceResponse";
import { IEmpresaCSD, ISATMetodoPago, ISATRegimenFiscal, ISATUsoCFDI } from "@/core/model/sys/IEmpresaCSD";

export default class GenericService extends BaseService
{
  constructor(param: IParamServices)
  {
    super(param);
  } 
  public NewCustomerType() : ICustomerType
  {
    return{
      CustomerTypeId:0,
      CustomerTypeName: '',
      ModifiedBy:0,
      ModifiedByEmployee:null,
      ModifiedTime: new Date(),
      AllowParent:false,
      Active: true
    };
  }
  public async ListCustomerType():Promise<ICustomerType[]>
  {
    const list = Array<ICustomerType>();
    const response:IServiceResponse = await this.Get('IndexGeneric/ListCustomerType',null,null,null,true,false,null);  
    if(response.Response)
    {      
      for (const element of response.Response)
      {        
        list.push({...element});  
      }
    }    
    return list;
  }
  public async SaveCustomerType(customerType:ICustomerType):Promise<ICustomerType|null>
  {
    const response:IServiceResponse =  await this.Post('IndexGeneric/SaveCustomerType',customerType,null,null,null,true,false,null);           
    if(response && response.Response)
    {      
      return response.Response;
    }
    else
      return null;
  }
   public async GetSATRegimenFiscal():Promise<ISATRegimenFiscal[]>
  {
    const response:IServiceResponse =  await this.Get('IndexGeneric/GetSATRegimenFiscal',null,null,null,true,false,null);           
    if(response && response.Response)
    {      
      return response.Response;
    }
    else
      return [];
  }
  public async GetSATUsoCFDI():Promise<ISATUsoCFDI[]>
  {
    const response:IServiceResponse =  await this.Get('IndexGeneric/GetSATUsoCFDI',null,null,null,true,false,null);           
    if(response && response.Response)
    {      
      return response.Response;
    }
    else
      return [];
  }
  public async GetSATMetodoPago():Promise<ISATMetodoPago[]>
  {
    const response:IServiceResponse =  await this.Get('IndexGeneric/GetSATMetodoPago',null,null,null,true,false,null);           
    if(response && response.Response)
    {      
      return response.Response;
    }
    else
      return [];
  }
  public async EmpresaCSD():Promise<IEmpresaCSD|null>
  {
    const response:IServiceResponse =  await this.Get('IndexGeneric/EmpresaCSD',null,null,null,true,false,null);           
    if(response && response.Response)
    {      
      return response.Response;
    }
    else
      return null;
  }
  public async SaveEmpresaCSD(csd:IEmpresaCSD):Promise<IEmpresaCSD|null>
  {
    const response:IServiceResponse =  await this.Post('IndexGeneric/SaveEmpresaCSD',csd,null,null,null,true,false,null);           
    if(response && response.Response)
    {      
      return response.Response;
    }
    else
      return null;
  }
  public async GetFiscalConfig():Promise<any>
  {
    const response:IServiceResponse =  await this.Get('IndexGeneric/GetFiscalConfig',null,null,null,true,false,null);           
    if(response && response.Response)
    {      
      return response.Response;
    }
    else
     return null;
  }
  public async SaveFiscalConfig(config:any):Promise<any>
  {
    const response:IServiceResponse =  await this.Post('IndexGeneric/SaveFiscalConfig',config,null,null,null,true,false,null);           
    if(response && response.Response)
    {      
      return response.Response;
    }
    else
      return null;
  }
}
